import React from 'react';

import { styled as muiStyled } from '@mui/material/styles';
import MuiDialogContent from '@mui/material/DialogContent';

const StyledDialogContent = muiStyled(MuiDialogContent)(
  ({ theme }) => `
  padding: ${theme.spacing(4)};
`,
);

export default StyledDialogContent;
